// import events from '@/core/events/events'
import ga from '@/components/google-analytics'

export const extendedBus = (bus) => {
  //
  const eventSource = bus.$emit
  const eventSink = bus.$on
  // const eventOnce = bus.$once
  // const eventOff = bus.$off

  function emitEvent (event, payload) {
    return eventSource.call(bus, event, payload)
  }
  function onEvent (event, cb) {
    return eventSink.call(bus, event, cb)
  }
  /* function onceEvent (event, cb) {
    return eventOnce.call(bus, event, cb)
  } */
  /* function offEvent (event, cb) {
    return eventOff.call(bus, event, cb)
  } */

  //
  ga.init()
  ga.setup()

  bus.$emit = function (event, payload, source) {
    let trackToGoogleAnalytics = false

    const _source = source || { name: global.app.currentModule }
    const _payload = {
      target: _source.name || source,
      data: payload
    }

    if (event) {
      //
      if (event.charAt(0) === '%') {
        event = event.substr(1)
        trackToGoogleAnalytics = true
      }

      emitEvent.call(bus, event, _payload)

      //
      trackToGoogleAnalytics && ga.track(_payload.target, event, payload)

      console.info('emitted', event, 'from', _source.name, 'with payload', _payload)
    } else {
      console.warn('this event is undefined')
    }
  }

  bus.$on = function (event, cb, sink, once) {
    console.info(`attached ${once ? 'once' : ''}`, event, 'with', cb.name)

    onEvent.call(bus, event, (payload) => {
      const _sink = sink && sink.default || {}

      console.info(`received ${once ? 'once' : ''}`, event, _sink.name ? 'in' : '', _sink.name ? _sink.name : '', 'with payload', payload)
      if (typeof cb === 'function') {
        cb(payload)
      }

      // once && offEvent.call(bus, event)
    })
  }

  /* bus.$once = function (event, cb, sink) {
    // bus.$on(event, cb, sink, true)
  }

  bus.$off = function (event, cb) {
    console.log('detached', event)

    offEvent.call(bus, event, cb)
  } */

  return bus
}



// WEBPACK FOOTER //
// ./src/core/events/extended-bus.js